import addMount from "../../core/addMount";
import BranchListEntry from "./branch-list.entry";

addMount({ appName: "branch-list", app: BranchListEntry });
